import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import Modal from '../../../../Components/Modal/Modal';
import PatientsGroupsRename from './PatientsGroupsRename';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
	group: {
		id: string;
		name: string;
		description?: string;
	};
}

const PatientsGroupsRenameModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSuccess,
	group,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.SM}>
			<Modal.Header title='base.editGroup' firstUpper />
			<Modal.Content>
				<PatientsGroupsRename group={group} onSuccess={onSuccess} />
			</Modal.Content>
		</Modal>
	);
};

export default PatientsGroupsRenameModal;
